import React from "react";

export default function AccountPanel({ children, className = "", header }) {
  return (
    <div className="profile_section">
      {header && (
        <div className="section_header">
          <h3>{header.title}</h3>
          {header.subtitle && <p>{header.subtitle}</p>}
        </div>
      )}
      <div className={`section_content ${className}`.trim()}>{children}</div>
    </div>
  );
}
